// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wyzdKR7GqYNvUEz23CTU {
	align-items: center;
	border-radius: 12px;
	border: none;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
	cursor: pointer;
	display: flex;
	font-size: 16px;
	height: 44px;
	justify-content: center;
	letter-spacing: -0.04em;
	line-height: 28px;
	padding: 0 8px;
	text-decoration: none;
}

.A3DQgut_3YZ3MINlxRNF {
	background-color: var(--white);
	color: var(--black);
}

.gmdGtJdyhV_ofYVSHRjF {
	background-color: var(--black);
	color: var(--white);
}

.iT279XQYdIitycr1ATl8 {
	background-color: var(--green);
	color: var(--black);
}

.LUUeOWShcOxg9MpUbmrO {
	opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/SymbiosisButton/SymbiosisButton.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,YAAY;CACZ,4CAA4C;CAC5C,eAAe;CACf,aAAa;CACb,eAAe;CACf,YAAY;CACZ,uBAAuB;CACvB,uBAAuB;CACvB,iBAAiB;CACjB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb","sourcesContent":[".container {\n\talign-items: center;\n\tborder-radius: 12px;\n\tborder: none;\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n\tcursor: pointer;\n\tdisplay: flex;\n\tfont-size: 16px;\n\theight: 44px;\n\tjustify-content: center;\n\tletter-spacing: -0.04em;\n\tline-height: 28px;\n\tpadding: 0 8px;\n\ttext-decoration: none;\n}\n\n.white {\n\tbackground-color: var(--white);\n\tcolor: var(--black);\n}\n\n.black {\n\tbackground-color: var(--black);\n\tcolor: var(--white);\n}\n\n.green {\n\tbackground-color: var(--green);\n\tcolor: var(--black);\n}\n\n.disabled {\n\topacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `wyzdKR7GqYNvUEz23CTU`,
	"white": `A3DQgut_3YZ3MINlxRNF`,
	"black": `gmdGtJdyhV_ofYVSHRjF`,
	"green": `iT279XQYdIitycr1ATl8`,
	"disabled": `LUUeOWShcOxg9MpUbmrO`
};
export default ___CSS_LOADER_EXPORT___;
